import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-date-user',
    templateUrl: './date-user.component.html',
    styleUrls: ['./date-user.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DateUserComponent implements OnInit {
  @Input() date: Date;
  @Input() user: string;

  constructor() {}

  ngOnInit(): void {}
}
